import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import Button from "./Button";

const Breadcrumb = ({ actionButtons, noNavigate, customBreadcrumb }) => {
  const location = useLocation();

  // Get the current URL path and split it into segments
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment !== "") // Remove empty segments
    .filter((segment) => segment !== "admin"); // Remove admin segments

  // Use customBreadcrumb if provided, otherwise use pathSegments
  const breadcrumbItems = customBreadcrumb || pathSegments;

  // Function to format the breadcrumb name (convert kebab-case or camelCase to normal words)
  const formatBreadcrumb = (segment) => {
    return segment
      .replace(/-/g, " ") // Replace hyphens with spaces
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  };

  return (
    <nav className="text-gray-600 text-sm font-medium py-3 px-4 flex flex-wrap justify-between">
      <ul className="flex items-center space-x-2">
        {/* Home Icon */}
        <li>
          <Link
            to="/"
            className="text-primary hover:underline flex items-center"
          >
            <FontAwesomeIcon icon={faHome} className="mr-1 text-primary" />
            {/* Admin */}
          </Link>
        </li>

        {/* Breadcrumb Items */}
        {breadcrumbItems.map((segment, index) => {
          const path = customBreadcrumb
            ? "#" // If using customBreadcrumb, don't navigate
            : "/" + pathSegments.slice(0, index + 1).join("/");

          return (
            <li key={index} className="flex items-center">
              {/* <span className="mx-1">/</span> */}
              {index === breadcrumbItems.length - 1 ? (
                // Last breadcrumb (no link, active)
                <span className="text-gray-800 uppercase">
                  {formatBreadcrumb(segment)}
                </span>
              ) : (
                // Intermediate breadcrumbs (clickable links)
                <Link
                  to={noNavigate || customBreadcrumb ? "#" : path}
                  className="text-primary hover:underline"
                >
                  {formatBreadcrumb(segment)}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
      <div className="flex gap-2">
        {actionButtons.map((item, index) => (
          <Button
            key={index}
            children={
              <span className="flex gap-2 items-center">
                {item.icon && <FontAwesomeIcon icon={item.icon} />}
                {item.label}
              </span>
            }
            onClick={item.onClick}
            size="small"
          />
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;
